/**
 * This component is a Modal that is shown on success
 */

import React, { useRef, useState } from "react";

import { Formik } from "formik";
/* Import react bootstrap component starts */
import { Modal } from "react-bootstrap";
/* Import react bootstrap component ends */

/* Import image and SVG starts */
/* Import image and SVG ends */

/* Import local pages and component starts */
import CustomTextArea from "../../../../ui/input/CustomTextArea/CustomTextArea";
import CustomButton from "../../../../ui/button/CustomButton/CustomButton";
import TextButton from "../../../../ui/button/TextButton/TextButton";
/* Import local pages and component ends */

import "./style.scss";
import { getUserTheme } from "../../../../../setup/store/slices/authSlice";
import { useSelector } from "react-redux";

/* Component starts */
const SoRejectModal = (props) => {
  /* Props destructuring starts */
  const { showModal, size = "lg", onClose, onCommentAdded, title } = props;
  /* Props destructuring ends */

  const userTheme = useSelector(getUserTheme);

  // Initial Values
  const initialFormValues = {
    description: "",
  };

  /* ************* Component rendering. JSX code ************* */
  return (
    <Modal
      size={size}
      centered
      show={showModal}
      className="so-reject-modal-wrapper"
    >
      <Modal.Body
        className={`${userTheme === "dark" ? "bg_darkTheme" : "bg_lightTheme"}`}
      >
        <div className="modal-header-custom">
          <p className="font_l fw_6 text-start font_blue">
            {title ? title : "SO Reject Comment"}
          </p>
        </div>
        <div className="modal-body-custom">
          <Formik
            onSubmit={(values) => onCommentAdded(values)}
            initialValues={initialFormValues}
            validateOnBlur={true}
            enableReinitialize={true}
          >
            {({
              values,
              errors,
              touched,
              handleBlur,
              handleChange,
              handleSubmit,
            }) => (
              <form onSubmit={handleSubmit}>
                {/* Form Fields */}
                <div className="form-wrapper form-wrapper-flex">
                  {/* Description */}
                  <div className="form-group form-group-full">
                    <CustomTextArea
                      name="description"
                      label="Description"
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      value={values.description}
                      errors={errors.description}
                      touched={touched.description}
                      required={true}
                    />
                  </div>
                </div>

                {/* Submit and Cancel */}
                <div className="button-wrapper text-center">
                  <>
                    <CustomButton type="submit" size="l">
                      Submit
                    </CustomButton>
                    <CustomButton
                      // {/* TextButton */}
                      // type="button"
                      type="submit"
                      size="l"
                      variant="red"
                      onClick={onClose}
                      className="font_m fw_6 mt-2"
                    >
                      Cancel
                    </CustomButton>
                  </>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
};
/* Component ends */

export default SoRejectModal;
